export const formatter = new Intl.NumberFormat("Af-ZA", {
  style: "currency",
  currency: "ZAR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const viewPropertyUK = 'https://askproperty.propviewr.com/en/uk/properties'
export const viewPropertyUAE = 'https://askproperty.propviewr.com/en/ae/properties'

